import { Component, Input } from '@angular/core';
import { CompanyResponse, CompanyDocumentResponse } from '../../../../../../@shared/models/response.module';
import { EndpointService } from '../../../../../../@shared/endpoints.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../../../@core/services/toast.service';

@Component({
  selector: 'app-add-document',
  standalone: false,
  templateUrl: './add-document.html',
  styleUrl: './add-document.css'
})
export class AddDocument {
  @Input() company: CompanyResponse;
  @Input() editMode: boolean = false;
  @Input() document: CompanyDocumentResponse | null = null;

  document_name = '';
  documentFile: File | null = null;

  saving = false;
  submitted = false;

  // Validation helpers
  get isDocumentNameInvalid(): boolean {
    return this.submitted && !this.document_name.trim();
  }

  get isFileInvalid(): boolean {
    return this.submitted && !this.editMode && !this.documentFile;
  }

  get isFormValid(): boolean {
    if (this.editMode) {
      return !!this.document_name.trim();
    }
    return !!this.documentFile && !!this.document_name.trim();
  }

  constructor(
    private endpointService: EndpointService,
    private modal: NgbActiveModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    if (this.editMode && this.document) {
      this.document_name = this.document.document_name || '';
    }
  }

  onSave() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('companyProfile.addDocument.validationError'));
      return;
    }

    if (this.saving) return;
    this.saving = true;

    if (this.editMode && this.document) {
      // Update existing document metadata
      this.endpointService.cor_coy_29(this.document.document_id, {
        company_id: this.company.company_id,
        document_name: this.document_name.trim()
      }).subscribe({
        next: (res) => {
          this.saving = false;
          this.toastService.success(this.translateService.instant('companyProfile.addDocument.updateSuccess'));
          this.modal.close(res.data);
        },
        error: (err) => {
          this.saving = false;
          this.toastService.error(err.error?.reason || this.translateService.instant('companyProfile.addDocument.updateError'));
        }
      });
    } else {
      // Upload new document
      this.endpointService.cor_coy_28({
        company_id: this.company.company_id,
        document: this.documentFile!,
        document_name: this.document_name.trim() || this.documentFile!.name
      }).subscribe({
        next: (res) => {
          this.saving = false;
          this.toastService.success(this.translateService.instant('companyProfile.addDocument.success'));
          this.modal.close(res.data);
        },
        error: (err) => {
          this.saving = false;
          this.toastService.error(err.error?.reason || this.translateService.instant('companyProfile.addDocument.error'));
        }
      });
    }
  }

  onFileSelected(files: File[]) {
    if (files && files.length > 0) {
      this.documentFile = files[0];
      // Auto-fill name if empty
      if (!this.document_name) {
        this.document_name = this.documentFile.name;
      }
    }
  }

  close() {
    this.modal.close();
  }
}
